module.exports = __webpack_public_path__ + "static/media/warning-sign.0886f4a5.svg";